/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonProposalTimeInfo } from './BabylonProposalTimeInfo';
import type { BabylonProposalVoteInfo } from './BabylonProposalVoteInfo';

export type BabylonProposalVotingPeriodInfo = {
    PPLID: string;
    EXP: BabylonProposalVotingPeriodInfo.EXP;
    TTL: string;
    TPLIST: Array<string>;
    VLIST: Array<BabylonProposalVoteInfo>;
    VT: BabylonProposalTimeInfo;
};

export namespace BabylonProposalVotingPeriodInfo {

    export enum EXP {
        Y = 'Y',
        N = 'N',
    }


}

